import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class TicketDialogService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  public openTicketDialog(ticketId: number): void {
    const urlTree = this.router.createUrlTree(
      [
        {
          outlets: {
            dialog: ['ask-hr-ticket', ticketId],
          },
        },
      ],
      { relativeTo: this.route },
    );
    this.router.navigateByUrl(urlTree);
  }
}
